module.exports = "/assets/49b5ff8f3ad5df186b9f4e1db4f484cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/9X.png
// module id = 1176
// module chunks = 0